/* buttonToTop.js */
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

const setbuttonToTop = () => {

  let button = document.querySelector('[data-buttonToTop]');

  if ( button ) {
    button.addEventListener("click", handleClick);
  }

} 

const destroybuttonToTop = () => {
  if ( ! button ) return;
  button.removeEventListener("click", handleClick);
}

function handleClick() {
  gsap.to(window, {duration: 2, scrollTo: 0, ease: "power2.inOut"});
}

export { setbuttonToTop, destroybuttonToTop }